module.exports = __webpack_public_path__ + "img/my_introduction.4138c4ce.png";